<template lang="pug">
#app
    MenuM(:year='year')
    section(id="top" data-aos="fade-down" data-aos-duration="2000")
        Intro(:year='year')
    section.About.section(id="ABOUT" data-aos="fade-up" data-aos-duration="1000")
        About(:year='year')
    section.Paper.section(id="PAPERS")
        Paper(:year='year')
    section.Keynotes.section(id="KEYNOTES" v-if="year<2026")
        Keynotes(:year='year')
    section.Panel.section(id="PANEL" v-if="year==2021")
        Panel(:year='year')
    section.Agenda.section(id="AGENDA" v-if="year<2026")
        Agenda(:year='year')
    section.Organizera.section(id="ORGANIZER")
        Staff(:year='year')
    section.Venue.section(id="VENUE")
        Contact(:year='year')
    section.Past.section(v-if="year>'2021'")
        .contentContainer
            h1.TitleU Past Workshop
            router-link.textSize(to='/?year=2025', v-if="year>'2025'") MIMSVAI 2025, Espoo, Finland<br>
            router-link.textSize(to='/?year=2024', v-if="year>'2024'") MIMSVAI 2024, Melbourne, Australia<br>
            router-link.textSize(to='/?year=2023', v-if="year>'2023'") MIMSVAI 2023, Cancún, Mexico<br>
            router-link.textSize(to='/?year=2022', v-if="year>'2022'") MIMSVAI 2022, Virtual, Global<br>
            router-link.textSize(to='/?year=2021') MIMSVAI 2021, Virtual, Global

    .socialCantainer(v-bind:class="{'social-top': isTop}")
        a.socialIcon.fbIcon(:style="{'background-image': 'url(' + fbImg + ')'}" :href="fbUrl" target="_blank")
        a.socialIcon.twIcon(:style="{'background-image': 'url(' + twitterImg + ')'}" :href="twUrl" target="_blank")
</template>

<script>
import MenuM from "@/components/MenuM.vue"
import Intro from "@/components/mainPage/Intro.vue"
import About from "@/components/mainPage/About.vue"
import Paper from "@/components/mainPage/Paper.vue"
import Staff from "@/components/mainPage/Staff.vue"
import Agenda from "@/components/mainPage/Agenda.vue"
import Contact from "@/components/mainPage/Contact.vue"
import Keynotes from "@/components/mainPage/Keynote.vue"
import Panel from "@/components/mainPage/Panel.vue"

export default {
    name: 'HomePage',
    components: {
        MenuM,
        Intro,
        About,
        Paper,
        Staff,
        Agenda,
        Contact,
        Keynotes,
        Panel
    },
    data () {
        return {
            data: '',
            menuList: '',
            fbImg: 'https://mimsvai.github.io/static/imgs/facebook-loge.png',
            twitterImg: 'https://mimsvai.github.io/static/imgs/twitter-logo.png',
            fbUrl: ' https://www.facebook.com/mimsvai',
            twUrl: 'https://twitter.com/mimsvai',
            isTop: false,
            year: 2026
        }
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll)
    },
    created() {
        if (this.$route.query.year) {
            this.year = this.$route.query.year
        }
        else {
            this.year = 2026
        }
    },
    watch:{
        $route (to, from){
            window.scrollTo(0, 0);
            if (this.$route.query.year) {
                this.year = this.$route.query.year
            }
            else {
                this.year = 2026
            }
        }
    },
    methods: {
        handleScroll: function (evt, el) {
            if(window.scrollY>300){
                this.isTop = false;
            }else{
                this.isTop = true;
            }
        }
    }
}

</script>

<style lang="sass">
@import "@/style/TextList.sass"
#ABOUT
    padding-top: 5vh !important
#top
    padding: 10vh 0 0 0
.section
    padding: 8vh 0 12vh 0
    transition: 1.5s all cubic-bezier(0.39, 0.575, 0.565, 1)
section
    opacity: 100
    transition: 2s

@media all and (max-width: 960px)
    .section
        padding: 10px
    .Paper
        padding: 10px 25px 30px 20px
    .Agenda
        padding: 10px 25px 30px 20px

//commom style
h1
    font-size: 28px
p
    font-size: 18px
    line-height: 24px

.Paper,.Agenda,.Venue
    background-color: #d1ebed
    // background-color: #c3d9db

.Panel,.Past
    background: #e5eeed

.socialCantainer
    display: flex
    flex-wrap: wrap
    justify-content: space-around
    position: fixed
    right: 0
    top: calc( 50% - 100px )
    width: 80px
    height: 150px
    background-color: #fffa
    border-radius: 8px
    transition: 0.4s
.social-top
    width: 90px
.socialIcon
    width: 60px
    height: 60px
    background-size: cover
    background-position: center
    background-repeat: no-repeat
    border-radius: 8px
    transition: 0.4s
    cursor: pointer
.fbIcon:hover
    background-color: #4267B2
.twIcon:hover
    background-color: #1DA1F2
.fbIcon
    background-color: #DB9F18
    margin-top: 10px
    background-size: auto 40px
.twIcon
    background-color: #DB8A18
    background-size: auto 30px
</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue